export default (function (_ref) {
  var service = _ref.service,
    request = _ref.request;
  return {
    getCapitalWithdrawList: function getCapitalWithdrawList() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/user_record/get",
        method: "get",
        params: data
      });
    },
    // 资金提现确认
    capitalWithdrawConfirm: function capitalWithdrawConfirm() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/user_record/operationConfirm",
        method: "post",
        data: data
      });
    },
    getCapitalRatio: function getCapitalRatio() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/ratio/getInfo",
        method: "get",
        params: data
      });
    },
    updateCapitalRatio: function updateCapitalRatio() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/ratio/update",
        method: "post",
        data: data
      });
    }
  };
});